import type * as React from 'react';

import { cn } from '../../lib/utils';

export interface AvatarProps {
  /** Initials to display. Uppercased and truncated to 2 characters. */
  initials: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeStyles: Record<NonNullable<AvatarProps['size']>, string> = {
  xs: 'w-7 h-7 text-[10px]',
  sm: 'w-6 h-6 text-[10px]',
  md: 'w-8 h-8 text-[12px]',
  lg: 'w-10 h-10 text-[14px]',
};

export const Avatar: React.FC<AvatarProps> = ({ initials, size = 'md', className }) => {
  const displayInitials = initials.toUpperCase().slice(0, 2);

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-dawn-orange text-white font-medium font-outfit',
        sizeStyles[size],
        className
      )}
    >
      {displayInitials}
    </div>
  );
};

Avatar.displayName = 'Avatar';
